import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BKBadge',
  props: {
    bordered: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    color: { default: 'var(--color-green)' },
    offsetX: { default: 18 },
    offsetY: { default: 13 },
    value: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})